/* globals jQuery */
import 'jquery-validation';

(function($) {
	if ($.validator) {
		$.validator.addMethod('currency', function (value, element) {
			return this.optional(element) || /^\d*(\.\d{2})?$/.test(value);
		}, 'Please enter an amount in USD');
		// With info from http://www.24hourapps.com/2009/02/jquery-international-phone-number.html
		$.validator.addMethod('phone', function(value, element) {
			return this.optional(element) || /^((\+)?[1-9]{1,2})?([-\s\.])?((\(\d{1,4}\))|\d{1,4})(([-\s\.])?[0-9]{1,12}){1,2}(\s*(ext|x)\s*\.?:?\s*([0-9]+))?$/.test(value);
		}, 'Please enter a valid phone number.');

		$.validator.addMethod('username', function(value, element) {
			return this.optional(element) || /^[a-zA-Z0-9\-]+$/.test(value);
		}, 'Please enter only letters, numbers and dashes.');

		$.validator.addMethod('notequalTo', function(value, element, param) {
			// bind to the blur event of the target in order to revalidate whenever the target field is updated
			// TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
			var target = $(param);
			if ( this.settings.onfocusout ) {
				target.unbind('.validate-notequalTo').bind('blur.validate-notequalTo', function() {
						$(element).valid();
					});
				}
				return value !== target.val();
			}
		);

		$.validator.addMethod('illegal', function (value, element) {
			return this.optional(element) || /^(?:(?!\broot\b|\bdaemon\b|\bsync\b|\bshutdown\b|\bhalt\b|\bmail\b|\bnews\b|\buucp\b|\boperator\b|\bgames\b|\bmysql\b|\bhttpd\b|\bnobody\b|\bdummy\b|\bshell\b|\bdebian\b|\bdownload\b|\banoncvs_\b).)*$/i.test(value);
		}, 'This is an invalid username.');

		$.validator.addMethod('checkuploads', function () {
			return ($('.name').find('#uploaded-file').length > 0);
		}, 'File upload is required');

		// Add method to not allow 0 alone (still allows 10, 102, 10.5, etc.)
		$.validator.addMethod('quantity', function(value, element) {
			return this.optional(element) || /^(?=.*[1-9])\d*\.?\d*$/.test(value);
		}, 'Please enter a valid quantity');

		$.validator.addMethod('pantone', function(value, element) {
			return this.optional(element) || /^[ \w.%#-]+$/i.test(value);
		}, 'Letters, numbers, and underscores only please');

		$.validator.addMethod('postcodeCA', function(postal, element) {
			return this.optional(element) || 
			postal.match(/[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/);
		}, 'Please specify a valid postal code');

		$.validator.addMethod('postcodeBR', function(postal, element) {
			return this.optional(element) || 
			postal.match(/\d{5}-\d{3}/);
		}, 'Please specify a valid postal code');

		$.validator.addMethod('postcodeNL', function(postal, element) {
			return this.optional(element) || 
			postal.match(/^[1-9][0-9]{3} ?(?!SA|SD|SS)[A-Z]{2}$/);
		}, 'Please specify a valid postal code');
	}
}(jQuery));